import {ApplicationStoreType} from 'reducers';
import {MODULE_KEY} from 'pages/cart/constants';

/**
 * Return id of added accessory to cart
 * @param {number} state - accessory id
 * @returns {Array<AccessoryType>} simple accessories list
 */
export const getCartAccessoriesId = (state: ApplicationStoreType): number =>
    state[MODULE_KEY].accessories.addingId;
